const parseQueryString = input =>
    input.slice(input.indexOf('?') + 1)
        .match(/[\w\d%\-!.~'()\*]+=[\w\d%\-!.~'()\*]+/g)
        .map(s => s.split('=').map(decodeURIComponent))
        .reduce((obj, [key, value]) => Object.assign(obj, { [key]: value }), {});

/*
 * tfa_value meanings:
 * tfa_52 - Builder name
 * tfa_53 - Package name
 * tfa_54 - Lot name
 */

export const onEnquireClick = (ev, tfa_52 = "", tfa_53 = "", tfa_54 = "" ) => {
    let iframe = window.jQuery('.iframe-form > iframe').attr('src');
    let url = new URL(iframe);

	let urlObject = (url.search === "") ? {} : parseQueryString(url.search);
    urlObject = Object.assign(urlObject, {tfa_52: tfa_52, tfa_53: tfa_53, tfa_54: tfa_54});

    var queryString = Object.keys(urlObject).map(key => key + '=' + urlObject[key]).join('&');
    let newsrc = `${url.origin}${url.pathname}?${queryString}`;

    window.jQuery( '.iframe-form > iframe' ).attr( 'src', newsrc );
    window.jQuery("a.enquire-now").click();
};


/** WEBPACK FOOTER **
 ** ./src/modules/common/onEnquireClick.js
 **/